export default {"src":"/_next/static/media/locked-in.95b0a9f8.svg","height":61,"width":47,"blurWidth":0,"blurHeight":0};